/* eslint-disable */
import moment from "moment";
import 'moment/locale/ru';
import hotelToNewFormatAdapter from '@/js/common/Domain/Repository/service/hotelToNewFormatAdapter';
import tourCriteriaService from "./tourCriteria";
import CheckInDateRangeFactory from "../Factory/checkInDateRange/CheckInDateRange";
import CountriesRepository from '../Repository/Countries';
import EntityManager from "../EntityManager";
import ResortsRepository from "../Repository/Resorts";
import HotelsRepository from "../Repository/Hotels";
import HotelFactory from "../Factory/Hotel";
import TourCriteriaFactory from "../Factory/TourCriteria";
import CountryFactory from "../Factory/Country";

let tourCriteriaHotelService = {};

$.extend(tourCriteriaHotelService, tourCriteriaService, {
    loadTourCriteriaWithFormDataHotel: function(params, callback, hotelInfo) {
        var setTourCriteria = params.setTourCriteria ? params.setTourCriteria : {},
			entityManager,
            setCheckInDateRange,
            today = moment();

        if(setTourCriteria && setTourCriteria['checkInDateRange'] && setTourCriteria['checkInDateRange']['from'] && setTourCriteria['checkInDateRange']['to']) {
            setCheckInDateRange = CheckInDateRangeFactory(setTourCriteria['checkInDateRange'], null, {
                disableOldDateCorrection:true
            });

            if(!setCheckInDateRange || !setCheckInDateRange.get('from') || !setCheckInDateRange.get('to') || (moment(setCheckInDateRange.get('from')) < today && moment(setCheckInDateRange.get('to')) < today)) {
                delete(setTourCriteria['checkInDateRange']);
            }
        }

        this.getRemoteFormData({
            success: function (departureCities, countries) {
                var tourCriteriaCountryId = setTourCriteria && setTourCriteria.countries && setTourCriteria.countries.length ? setTourCriteria.countries[0] : (typeof window.appConfig.defaultCountryId !== "undefined" ? window.appConfig.defaultCountryId : null),
                    tourCriteriaDepartureCityId = setTourCriteria?.departureCity,
                    defaultDepartureCityId = window.appConfig.defaultDepartureCityId,
                    defaultTourCriteria,
                    tourCriteriaType,
                    tourCriteriaCountry,
                    tourCriteriaDepartureCity;

                if (tourCriteriaCountryId && countries.get(tourCriteriaCountryId)) {
                    tourCriteriaCountry = countries.get(tourCriteriaCountryId);
                } else {
                    tourCriteriaCountry = countries.min(function (country) {
                        return country.get('position');
                    });
                    tourCriteriaCountryId = tourCriteriaCountry.get('id');
                }

                if (tourCriteriaDepartureCityId && departureCities?.get(tourCriteriaDepartureCityId)) {
                    tourCriteriaDepartureCity = departureCities.get(tourCriteriaDepartureCityId);
                } else {
                    tourCriteriaDepartureCity = departureCities.get(tourCriteriaDepartureCityId) || departureCities.get(2);
                    tourCriteriaDepartureCityId = tourCriteriaDepartureCity?.get('id');
                }

                tourCriteriaType = tourCriteriaDepartureCity.get('type');

                defaultTourCriteria = $.extend({}, tourCriteriaCountry.get(tourCriteriaType + 'TourCriteria'), setTourCriteria, {
                    departureCity: tourCriteriaDepartureCityId,
                    countries: [hotelInfo.country],
                    hotelCategories:[hotelInfo.category],
                    resorts:[hotelInfo.resort],
                    hotels:[hotelInfo.id]
                });


                if(!CountriesRepository.repository.get(hotelInfo.country)) {
					entityManager = new EntityManager();
					entityManager.add({
						factory: CountryFactory,
						repository: CountriesRepository.repository
					}, {
					    id:hotelInfo.country,
                        name:hotelInfo.countryName
                    }, {merge: false});
                }
                ResortsRepository.repository.init([{id: hotelInfo.resort, name:hotelInfo.resortName}], hotelInfo.country);
                HotelsRepository.repository.add(new HotelFactory(hotelToNewFormatAdapter(hotelInfo)));

                callback && callback.success ? callback.success(new TourCriteriaFactory(defaultTourCriteria, {
                    defaultTourCriteria: defaultTourCriteria
                })) : ''
            }
        });
    }
});

export default tourCriteriaHotelService;
